import api from "../services/api";
import { getBackendUrl } from "../config";

// ===================================================================
// Sons do sistema. Todos sao SINTETIZADOS no navegador (Web Audio): nao ha
// arquivo de audio para baixar. Cada EVENTO (nova mensagem, aviso, cliente
// transferido, mensagem enviada) usa um SOM da biblioteca abaixo, com volume
// proprio. A escolha fica em Configuracoes > Sons e notificacoes e vale para
// toda a equipe (Setting "sonsNotificacao").
// ===================================================================

let audioCtx = null;

const getCtx = () => {
  if (!audioCtx) {
    audioCtx = new (window.AudioContext || window.webkitAudioContext)();
  }
  // O navegador deixa o audio "suspenso" ate a pessoa clicar na pagina.
  if (audioCtx.state === "suspended") {
    try { audioCtx.resume(); } catch (e) {}
  }
  return audioCtx;
};

// Chamado no primeiro clique/tecla da pagina: sem isso o Chrome bloqueia o som.
export const destravarAudio = () => {
  try { getCtx(); } catch (e) {}
};

// Um tom com envelope (ataque rapido + decaimento). freqFim faz "deslizar".
const tom = (ctx, saida, freq, inicio, dur, opt = {}) => {
  const { tipo = "sine", vol = 0.5, ataque = 0.005, freqFim = null, sustentar = false } = opt;
  const osc = ctx.createOscillator();
  const g = ctx.createGain();
  osc.type = tipo;
  osc.frequency.setValueAtTime(freq, inicio);
  if (freqFim) osc.frequency.exponentialRampToValueAtTime(freqFim, inicio + dur);
  g.gain.setValueAtTime(0.0001, inicio);
  g.gain.exponentialRampToValueAtTime(vol, inicio + ataque);
  if (sustentar) g.gain.setValueAtTime(vol, inicio + dur - 0.02);
  g.gain.exponentialRampToValueAtTime(0.0001, inicio + dur);
  osc.connect(g);
  g.connect(saida);
  osc.start(inicio);
  osc.stop(inicio + dur + 0.03);
};

// Biblioteca de sons prontos. "t" = instante de inicio.
export const SONS = [
  {
    id: "bolha", nome: "Bolha", detalhe: "Dois toques suaves, estilo mensageiro",
    tocar: (c, s, t) => { tom(c, s, 600, t, 0.1, { vol: 0.35 }); tom(c, s, 800, t + 0.1, 0.15, { vol: 0.35 }); },
  },
  {
    id: "gota", nome: "Gota", detalhe: "Pingo d'água curto e discreto",
    tocar: (c, s, t) => { tom(c, s, 1400, t, 0.14, { vol: 0.45, freqFim: 420 }); tom(c, s, 1800, t + 0.16, 0.08, { vol: 0.15, freqFim: 900 }); },
  },
  {
    id: "pop", nome: "Pop", detalhe: "Estalo único bem curto",
    tocar: (c, s, t) => { tom(c, s, 400, t, 0.1, { vol: 0.3 }); },
  },
  {
    id: "ding", nome: "Ding", detalhe: "Dois tons de notificação",
    tocar: (c, s, t) => { tom(c, s, 700, t, 0.12, { tipo: "triangle", vol: 0.45 }); tom(c, s, 900, t + 0.1, 0.22, { tipo: "triangle", vol: 0.45 }); },
  },
  {
    id: "cristal", nome: "Cristal", detalhe: "Três notas agudas, brilhante",
    tocar: (c, s, t) => {
      [1318.5, 1568, 2093].forEach((f, i) => tom(c, s, f, t + i * 0.09, 0.45, { tipo: "triangle", vol: 0.3 }));
    },
  },
  {
    id: "sino", nome: "Sino", detalhe: "Badalada com eco longo",
    tocar: (c, s, t) => {
      tom(c, s, 880, t, 1.4, { vol: 0.4 });
      tom(c, s, 880 * 2.76, t, 0.8, { vol: 0.12 });
      tom(c, s, 880 * 5.4, t, 0.4, { vol: 0.06 });
    },
  },
  {
    id: "marimba", nome: "Marimba", detalhe: "Toque de madeira, alegre",
    tocar: (c, s, t) => {
      [[523.25, 0], [784, 0.13], [1046.5, 0.26]].forEach(([f, d]) => {
        tom(c, s, f, t + d, 0.22, { vol: 0.45 });
        tom(c, s, f * 4, t + d, 0.06, { vol: 0.08 });
      });
    },
  },
  {
    id: "harpa", nome: "Harpa", detalhe: "Escala rápida subindo",
    tocar: (c, s, t) => {
      [523.25, 587.33, 659.25, 783.99, 880, 1046.5].forEach((f, i) => tom(c, s, f, t + i * 0.06, 0.5, { tipo: "triangle", vol: 0.22 }));
    },
  },
  {
    id: "acorde", nome: "Acorde", detalhe: "Acorde aberto, calmo",
    tocar: (c, s, t) => {
      [392, 523.25, 659.25, 783.99].forEach((f, i) => tom(c, s, f, t + i * 0.04, 0.9, { vol: 0.18, ataque: 0.02 }));
    },
  },
  {
    id: "digital", nome: "Digital", detalhe: "Bip-bip eletrônico",
    tocar: (c, s, t) => { tom(c, s, 1500, t, 0.07, { tipo: "square", vol: 0.18, sustentar: true }); tom(c, s, 1500, t + 0.12, 0.07, { tipo: "square", vol: 0.18, sustentar: true }); },
  },
  {
    id: "alarme", nome: "Alarme", detalhe: "Bipes alternados, alto e insistente",
    tocar: (c, s, t) => {
      for (let i = 0; i < 8; i++) tom(c, s, i % 2 === 0 ? 1046 : 784, t + i * 0.3, 0.22, { tipo: "square", vol: 0.45, ataque: 0.01, sustentar: true });
    },
  },
  {
    id: "sirene", nome: "Sirene", detalhe: "Sobe e desce, impossível não ouvir",
    tocar: (c, s, t) => {
      for (let i = 0; i < 3; i++) {
        tom(c, s, 650, t + i * 0.7, 0.35, { tipo: "sawtooth", vol: 0.22, freqFim: 1300, sustentar: true });
        tom(c, s, 1300, t + i * 0.7 + 0.35, 0.35, { tipo: "sawtooth", vol: 0.22, freqFim: 650, sustentar: true });
      }
    },
  },
  {
    id: "despertador", nome: "Despertador", detalhe: "Rajadas rápidas de bipes",
    tocar: (c, s, t) => {
      for (let g = 0; g < 3; g++) for (let i = 0; i < 4; i++) {
        tom(c, s, 2000, t + g * 0.6 + i * 0.08, 0.05, { tipo: "square", vol: 0.25, sustentar: true });
      }
    },
  },
  {
    id: "campainha", nome: "Campainha", detalhe: "Ding-dong de porta, chegou alguém",
    tocar: (c, s, t) => {
      tom(c, s, 659.25, t, 0.6, { vol: 0.45 }); tom(c, s, 659.25 * 3, t, 0.25, { vol: 0.06 });
      tom(c, s, 523.25, t + 0.45, 0.9, { vol: 0.45 }); tom(c, s, 523.25 * 3, t + 0.45, 0.3, { vol: 0.06 });
    },
  },
  {
    id: "moeda", nome: "Moeda", detalhe: "Plim de moeda, ótimo para venda",
    tocar: (c, s, t) => { tom(c, s, 988, t, 0.09, { tipo: "square", vol: 0.2, sustentar: true }); tom(c, s, 1319, t + 0.09, 0.45, { tipo: "square", vol: 0.2 }); },
  },
  {
    id: "fanfarra", nome: "Fanfarra", detalhe: "Comemoração curta",
    tocar: (c, s, t) => {
      [[523.25, 0, 0.12], [659.25, 0.12, 0.12], [783.99, 0.24, 0.12], [1046.5, 0.36, 0.6]].forEach(([f, d, dur]) => {
        tom(c, s, f, t + d, dur, { tipo: "triangle", vol: 0.38 });
        tom(c, s, f * 2, t + d, dur, { tipo: "sine", vol: 0.08 });
      });
    },
  },
  {
    id: "atencao", nome: "Atenção", detalhe: "Grave-agudo duas vezes, sério",
    tocar: (c, s, t) => {
      [0, 0.5].forEach((d) => { tom(c, s, 440, t + d, 0.18, { tipo: "triangle", vol: 0.45, sustentar: true }); tom(c, s, 880, t + d + 0.2, 0.22, { tipo: "triangle", vol: 0.45, sustentar: true }); });
    },
  },
  {
    id: "suave", nome: "Suave", detalhe: "Nota única bem baixinha",
    tocar: (c, s, t) => { tom(c, s, 1046.5, t, 0.5, { vol: 0.18, ataque: 0.02 }); },
  },
  { id: "nenhum", nome: "Sem som", detalhe: "Não toca nada", tocar: () => {} },
];

// Eventos que tocam som. O sistema de RH e usado por uma pessoa so, entao a
// tela mostra apenas os essenciais. Os demais continuam na lista (a
// configuracao salva nao quebra), mas ficam ocultos: ou mudos, ou usando o
// som de um evento essencial ("usa").
export const GRUPOS_SONS = [
  { id: "candidatos", nome: "Candidatos" },
  { id: "assistente", nome: "Assistente e entrevistas" },
  { id: "conexoes", nome: "WhatsApp" },
];

export const EVENTOS = [
  {
    id: "novoCliente", grupo: "candidatos",
    nome: "Novo candidato chegou",
    detalhe: "Primeira mensagem de um candidato que acabou de entrar em contato.",
    padrao: "campainha", volume: 70,
  },
  {
    id: "mensagem", grupo: "candidatos",
    nome: "Mensagem de candidato",
    detalhe: "Um candidato que você está atendendo mandou mensagem.",
    padrao: "bolha", volume: 70,
  },
  {
    id: "precisaHumano", grupo: "assistente",
    nome: "Candidato precisa de você",
    detalhe: "A assistente passou o atendimento para você e o candidato está esperando.",
    padrao: "atencao", volume: 80,
  },
  {
    id: "venda", grupo: "assistente",
    nome: "Entrevista agendada",
    detalhe: "A assistente agendou uma entrevista com um candidato.",
    padrao: "moeda", volume: 70,
  },
  {
    id: "conexaoCaiu", grupo: "conexoes",
    nome: "WhatsApp desconectado",
    detalhe: "O número caiu e não voltou sozinho (ou precisa ler o QR Code de novo).",
    padrao: "sirene", volume: 70,
  },

  // ── Ocultos ──
  { id: "transferencia", oculto: true, usa: "precisaHumano", padrao: "atencao", volume: 80 },
  { id: "monitor", oculto: true, padrao: "nenhum", volume: 0 },
  { id: "avisoIA", oculto: true, padrao: "nenhum", volume: 0 },
  { id: "comunicado", oculto: true, padrao: "nenhum", volume: 0 },
  { id: "problema", oculto: true, padrao: "nenhum", volume: 0 },
  { id: "conexaoVoltou", oculto: true, padrao: "nenhum", volume: 0 },
  { id: "envio", oculto: true, padrao: "nenhum", volume: 0 },
];

export const EVENTOS_VISIVEIS = EVENTOS.filter((e) => !e.oculto);

export const configPadraoSons = () =>
  EVENTOS.reduce((acc, e) => ({ ...acc, [e.id]: { som: e.padrao, volume: e.volume } }), {});

let config = configPadraoSons();

// Aceita o valor da Setting (texto JSON) ou o objeto ja pronto.
export const aplicarConfigSons = (valor) => {
  try {
    const obj = typeof valor === "string" ? JSON.parse(valor || "{}") : valor || {};
    const base = configPadraoSons();
    EVENTOS.forEach((e) => {
      const v = obj[e.id] || {};
      base[e.id] = {
        som:
          SONS.some((s) => s.id === v.som) || String(v.som || "").startsWith("arquivo:")
            ? v.som
            : e.padrao,
        volume: Number.isFinite(Number(v.volume)) ? Math.max(0, Math.min(100, Number(v.volume))) : e.volume,
      };
    });
    config = base;
  } catch (e) {
    config = configPadraoSons();
  }
  return config;
};

export const configAtualSons = () => config;

export const carregarConfigSons = async () => {
  try {
    // _ = evita que o navegador devolva uma copia antiga guardada em cache
    const { data } = await api.get("/public-settings/sonsNotificacao", {
      params: { _: Date.now() },
    });
    if (data?.value) aplicarConfigSons(data.value);
  } catch (e) {
    /* sem configuracao salva: fica o padrao */
  }
  return config;
};

// ---------- audios proprios (MP3 etc. enviados em Configuracoes) ----------
// Toca no maximo 10s: musica inteira como aviso atrapalha o atendimento.
const DURACAO_MAX_ARQUIVO_MS = 10 * 1000;
let previaAtual = null;

const urlDoArquivo = (somId) =>
  `${getBackendUrl()}public/sons/${encodeURIComponent(String(somId).replace(/^arquivo:/, ""))}`;

const tocarArquivo = (somId, volume, aoFalhar) => {
  try {
    if (previaAtual) {
      previaAtual.pause();
      previaAtual = null;
    }
    const audio = new Audio(urlDoArquivo(somId));
    audio.volume = Math.max(0, Math.min(1, volume / 100));
    previaAtual = audio;
    const parar = setTimeout(() => audio.pause(), DURACAO_MAX_ARQUIVO_MS);
    audio.addEventListener("ended", () => clearTimeout(parar));
    // arquivo apagado ou que o navegador nao toca: usa o som padrao do evento
    audio.addEventListener("error", () => { clearTimeout(parar); if (aoFalhar) aoFalhar(); });
    const p = audio.play();
    if (p && p.catch) p.catch(() => {});
  } catch (e) {
    if (aoFalhar) aoFalhar();
  }
};

// Lista dos audios proprios (para os menus de Configuracoes).
export const listarSonsPersonalizados = async () => {
  try {
    const { data } = await api.get("/sons-personalizados", { params: { _: Date.now() } });
    return Array.isArray(data) ? data : [];
  } catch (e) {
    return [];
  }
};

export const pararPrevia = () => {
  if (previaAtual) {
    previaAtual.pause();
    previaAtual = null;
  }
};

const tocarSomId = (somId, volume, aoFalhar) => {
  if (String(somId || "").startsWith("arquivo:")) {
    if (volume) tocarArquivo(somId, volume, aoFalhar);
    return;
  }
  try {
    const som = SONS.find((s) => s.id === somId);
    if (!som || som.id === "nenhum" || !volume) return;
    const ctx = getCtx();
    const tocarAgora = () => {
      const mestre = ctx.createGain();
      mestre.gain.value = (volume / 100) * 1.1;
      mestre.connect(ctx.destination);
      som.tocar(ctx, mestre, ctx.currentTime + 0.02);
    };
    // Audio suspenso (pagina sem clique, aba que o Chrome pausou): NAO agenda.
    // Antes o som ficava parado na fila e, quando o audio voltava, todos os
    // avisos acumulados tocavam juntos e atrasados (3 sinais de uma vez).
    // Agora: tenta destravar; se nao destravar em 1,5s, esse som e descartado.
    if (ctx.state !== "running") {
      const pedido = Date.now();
      Promise.resolve(ctx.resume && ctx.resume())
        .then(() => {
          if (ctx.state === "running" && Date.now() - pedido < 1500) tocarAgora();
        })
        .catch(() => {});
      return;
    }
    tocarAgora();
  } catch (e) {}
};

// Mesmo evento tocando de novo em menos de 2,5s (aviso repetido, duas abas do
// sistema abertas) toca uma vez so.
const ultimoSom = new Map();
const JANELA_SOM_MS = 2500;
const jaTocouAgora = (evento) => {
  const agora = Date.now();
  if (agora - (ultimoSom.get(evento) || 0) < JANELA_SOM_MS) return true;
  ultimoSom.set(evento, agora);
  // entre abas: a primeira que tocar marca no localStorage
  try {
    const chave = `som_ultimo_${evento}`;
    const outra = Number(localStorage.getItem(chave) || 0);
    if (agora - outra < JANELA_SOM_MS) return true;
    localStorage.setItem(chave, String(agora));
  } catch (e) {
    /* sem localStorage: vale so a trava desta aba */
  }
  return false;
};

// Toca o som configurado para o evento.
export const tocarSom = (eventoPedido) => {
  // Evento oculto: ou toca o som do evento essencial que ele usa, ou nada.
  const definicao = EVENTOS.find((e) => e.id === eventoPedido);
  const evento = definicao?.oculto ? definicao.usa : eventoPedido;
  if (!evento) return;
  const c = config[evento];
  if (!c) return;
  if (jaTocouAgora(evento)) return;
  const padrao = (EVENTOS.find((e) => e.id === evento) || {}).padrao;
  tocarSomId(c.som, c.volume, () => tocarSomId(padrao, c.volume));
};

// Previa na tela de Configuracoes (som e volume escolhidos, sem salvar).
export const tocarPrevia = (somId, volume = 70) => tocarSomId(somId, volume);

// Nomes antigos, usados pelo resto do sistema.
export const playReceiveMessageSound = () => tocarSom("mensagem");
export const playTransferSound = () => tocarSom("avisoIA");
export const playAlarmeTransferencia = () => tocarSom("transferencia");
export const playSendMessageSound = () => tocarSom("envio");
